const input = "_input_z5fxi_57";
const focus = "_focus_z5fxi_70";
const invalid = "_invalid_z5fxi_73";
const valid = "_valid_z5fxi_76";
const disabled = "_disabled_z5fxi_79";
const styles = {
  input,
  focus,
  invalid,
  valid,
  disabled
};
export {
  styles as default,
  disabled,
  focus,
  input,
  invalid,
  valid
};
//# sourceMappingURL=Input.module.scss.js.map
